import { render, staticRenderFns } from "./DirectoryInformatiomPreview.vue?vue&type=template&id=2468512d"
import script from "./DirectoryInformatiomPreview.vue?vue&type=script&lang=js"
export * from "./DirectoryInformatiomPreview.vue?vue&type=script&lang=js"
import style0 from "./DirectoryInformatiomPreview.vue?vue&type=style&index=0&id=2468512d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports